const modifyMarkup = (markup = "") => {
  // Trim markup of naughty newlines, carriage returns and more than 1 space
  const trimmedMarkup = markup
    .replace(/\n|\r/g, "")
    .replace(/\s\s+/g, " ")
    .replace(/> </g, "><");

  // Identify images and add class dependant on whether the image is alone in
  // a paragraph or is found inline after text
  const identifyImage = /<p><span class="gatsby-resp-image-wrapper(?:(?!<\/p>).)*<\/span><\/p>/g;
  const addImageClass = " class='articleImage'";

  // Make all internal links local
  const identifyURL = /href="(http|https):\/\/(?:www\.)?ustwo.com/g;
  const changeURL = `href="`;

  // Title
  // const identifyH2 = /<h2>/g;
  // const addH3Class = " class='h3'";

  return trimmedMarkup
    .replace(
      new RegExp(identifyImage),
      (match) =>
        match.slice(0, 2) + addImageClass + match.slice(2, match.length)
    )
    .replace(identifyURL, changeURL);
    // .replace(
    //   new RegExp(identifyH2),
    //   (match) => match.slice(0, 3) + addH3Class + match.slice(3, match.length)
    // )
};

export default modifyMarkup;
